var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-success"},[_vm._v(" "+_vm._s(_vm.computedValue)+" "),(_vm.computedAuthenticated)?_c('b-icon-check2',{attrs:{"aria-hidden":"true"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }